<template>
    <div>
        <b-modal v-model="value" size="md" no-close-on-backdrop scrollable>
            <div role="document">
                <div class="modal-content">
                    <div class="modal-headerfrm">
                        <h4 class="modal-title">Reason</h4>
                    </div>
                    <div class="modal-bodyfrm">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <span style="color: red;">Previous day Shipments allocated to SR are still pending to
                                        allocate!!</span>
                                    <span style="color: black; margin-top: 3px;">Please select the reason of
                                        non-allocation</span>
                                </div>
                                <div class="col-md-8 mt-4">
                                    <label>Select Reason:</label>
                                    <b-input-group left="<i class='fa fa-user'></i>">
                                        <basic-select :options="UserList" :selected-option="UserObj" v-model="User"
                                            name="User" placeholder="Select reason" @select="selectUser"
                                            v-bind:class="{ 'form-control': true }">
                                        </basic-select>
                                    </b-input-group>
                                </div>
                                <div class="col-md-8 mt-4">
                                    <button type="button"
                                        class="btn btn-success">Submit</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal v-model="PDDPopup" size="md" no-close-on-backdrop scrollable>
            <div role="document">
                <div class="modal-content">
                    <div class="modal-headerfrm">
                        <h4 class="modal-title">Reason</h4>
                    </div>
                    <div class="modal-bodyfrm">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <span style="color: red;">PDD breached or Due today shipments still pending to
                                        allocate!!</span>
                                    <span style="color: black; margin-top: 3px;">Please select the reason of
                                        non-allocation</span>
                                </div>
                                <div class="col-md-8 mt-4">
                                    <label>Select Reason:</label>
                                    <b-input-group left="<i class='fa fa-user'></i>">
                                        <basic-select :options="UserList" :selected-option="UserObj" v-model="User"
                                            name="User" placeholder="Select reason" @select="selectUser"
                                            v-bind:class="{ 'form-control': true }">
                                        </basic-select>
                                    </b-input-group>
                                </div>
                                <div class="col-md-8 mt-4">
                                    <button type="button"
                                        class="btn btn-success">Submit</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="vehiclePopup" size="md" no-close-on-backdrop scrollable>
            <div role="document">
                <div class="modal-content">
                    <div class="modal-headerfrm">
                        <h4 class="modal-title">Reason</h4>
                    </div>
                    <div class="modal-bodyfrm">
                        <div class="row">
                            <div class="col-md-12" style="padding: 0%;">
                                <div class="col-md-12">
                                    <span style="color: red;">Please enter vehicle for Ewaybill required shipments!!</span>
                                </div>
                                <div class="col-md-12 mt-4">
                                    <table class="table-bordered table-hover tbl datatables" style="width:100%;">
                                        <thead class="thead-default tablehead">
                                            <tr class="text-primary">
                                                <th class="text-center tableheader">Shipping Id</th>
                                                <th class="text-center tableheader">Vehicle No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in shippingData" :key="index" class="text-center">
                                                <td>{{ item.shippingid }}</td>
                                                <td><input  type="number" name="VehicalNo"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-8 mt-5" style="margin-left: 30%;">
                                    <button type="button"
                                        class="btn btn-success">Save</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>
  
<script>

export default {
    name: 'b-modalstemplate',
    components: {
    },
    data: function () {
        return {
            shippingData: [
                { shippingid: '12345', vehicleNo: 'ABC123' },
                { shippingid: '67890', vehicleNo: 'XYZ789' },
            ]
        }
    },
    props: {
        value: {
            type: Boolean,
        },
        PDDPopup: {
            type: Boolean,
        },
        vehiclePopup: {
            type: Boolean,
        },
        ShipVehiclTable: {
            type: Array,
        }
    },
    methods: {
        //   closeShipmentModel(){
        //     this.$emit("input", !this.value);
        //   }
    }
}

</script>
  
<style></style>
  


// WEBPACK FOOTER //
// src/views/components/CommonAllocation/b-modalsTemplate.vue?07c07fab